export default {
  tradeInfo: {
    news: {
      eyebrow: '最新情報',
      title: '業界ニュース',
    },
    resources: {
      eyebrow: 'ナレッジベース',
      title: '貿易リソース',
    },
    newsItems: [
      { date: '2024年12月', title: '日本の化学業界見通し2025', description: '来年の日本の化学セクターの市場トレンドと成長予測の分析。', category: '市場分析' },
      { date: '2024年11月', title: '輸出規制の最新情報', description: '日本からの国際貿易に影響する化学品輸出規制の重要な更新情報。', category: '規制' },
      { date: '2024年10月', title: 'レアアースサプライチェーンの動向', description: 'レアアース元素のサプライチェーンの最新動向と世界市場への影響。', category: 'サプライチェーン' },
      { date: '2024年9月', title: '化学製造における持続可能性', description: '日本のメーカーが持続可能な化学製造の実践においてリードする方法。', category: '持続可能性' },
    ],
    resourceItems: [
      { icon: 'ri-file-chart-line', title: '市場レポート', description: '化学市場のトレンドと予測の包括的な分析' },
      { icon: 'ri-government-line', title: '規制情報', description: '化学品貿易規制とコンプライアンス要件の最新変更' },
      { icon: 'ri-truck-line', title: '物流インサイト', description: '輸送、通関、国際物流に関する情報' },
      { icon: 'ri-lightbulb-line', title: '業界イノベーション', description: '化学業界の新しい動向と技術' },
    ],
    cta: {
      title: 'もっと詳しく知りたいですか？',
      description: '詳細な市場情報と貿易コンサルティングについては、当社チームにお問い合わせください。',
      btn: 'お問い合わせ',
    },
  },
};
